var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.orders'),"text":_vm.$t('orders.description'),"name":"orders","url":_vm.$listRoutes.orders,"table":_vm.orders,"filters":_vm.ordersFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }